<template>
  <div role="presentation">
    <AccordionPanel
      v-for="(item, idx) in data"
      :key="idx"
      class="mb-6 lg:mb-9"
      :idx="idx"
      :active="activeIdx === idx"
      isAnimated
      @expand="expandAccordion(idx)"
    >
      <template #title><div class="text-base lg:text-4xl font-semibold">{{ item.headline }}</div></template>
      <template #content>{{ item.description }}</template>
    </AccordionPanel>
  </div>
</template>

<script setup lang="ts">
import { AccordionPanelProps } from '~/components/accordion/AccordionPanel.vue'

defineProps({
  data: {
    type: Array as PropType<AccordionPanelProps[]>,
    default: () => []
  }
})

const activeIdx = ref<number | null>(null)

function expandAccordion(idx: number) {
  activeIdx.value = activeIdx.value !== idx ? idx : null
}
</script>
